import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MsalInteractionService {
  clearStaleInteraction(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (this.hasAuthResponseInUrl()) {
      return;
    }

    try {
      this.clearInteractionStatus(window.sessionStorage);
    } catch {
      // Storage can be blocked by browser settings; ignore.
    }

    try {
      this.clearInteractionStatus(window.localStorage);
    } catch {
      // Storage can be blocked by browser settings; ignore.
    }
  }

  private clearInteractionStatus(storage: Storage): void {
    if (!storage) {
      return;
    }

    const interactionKeys = this.findKeys(
      storage,
      (key) => key.startsWith('msal.') && key.includes('interaction.status')
    );
    if (interactionKeys.length === 0) {
      return;
    }

    const hasTempKeys = this.findKeys(storage, (key) => this.isMsalTempKey(key)).length > 0;
    if (hasTempKeys) {
      return;
    }

    const keysToRemove = [
      ...interactionKeys,
      ...this.findKeys(storage, (key) => this.isMsalTempKey(key)),
    ];

    keysToRemove.forEach((key) => storage.removeItem(key));
  }

  private hasAuthResponseInUrl(): boolean {
    const search = window.location.search ?? '';
    const hash = window.location.hash ?? '';
    const url = `${search}&${hash}`;
    return /(?:^|[&#?])(code|id_token|access_token|error)=/i.test(url);
  }

  private findKeys(storage: Storage, predicate: (key: string) => boolean): string[] {
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (!key) {
        continue;
      }
      if (predicate(key)) {
        keys.push(key);
      }
    }
    return keys;
  }

  private isMsalTempKey(key: string): boolean {
    if (!key.startsWith('msal.')) {
      return false;
    }

    return (
      key.includes('request.origin') ||
      key.includes('urlHash') ||
      key.includes('request.params') ||
      key.includes('code.verifier') ||
      key.includes('request.native')
    );
  }
}
